import { FormEvent } from "react"
import MarginBox from "../../shared/components/other/MarginBox"
import Navbar from "../../shared/components/navbar/NavBar"
import GameCard from "../Сalendar/components/GameCard"
import { cardInfoArray } from "../Сalendar/misc/Games"
import Button from "../../shared/components/UI/Button"
import Footer from "../../shared/components/other/Footer"
import './LocationMeet.scss'
import Slider from "./components/Slider"
import Map from "../../shared/components/Map/Map"
import { translateTags as translateTags } from "../../shared/services/CalendarServices"
import { useNavigate, useParams } from "react-router";
import useGroundsValues from "../../shared/hooks/useGroundsValues";
import { displayNotImplemented } from "../../shared/services/Notifications/NotificationServices";
import Loading from "../../shared/components/Loading/loading";
import useEventCards from "../../shared/hooks/useEventCards"

/* за 18.02
  в консоли выводит ошибку о требовании добавить атрибут key в каждый компонент из списка 
  (имеется нввиду не тег Ul, а когда ты циклом создаешь компоненты. 
  В качестве самого быстрого (но не безопасного в некоторых случаях) решения, просто добавь атрибут key по номеру в списке для создваемых органиаторов)
  по поводу того, что он не безопасен, бывают случаи, когда размер массива тэгов динамически меняется, и если мы будем присваивтаь им key по индексу в массиве у нас будут дубли при некоторых комбинациях изменений 
*/

export default function LocationMeet() {

  const navigate = useNavigate();

  const { guID } = useParams();

  // get запрос
  const { data, isLoading, error } = useGroundsValues(guID);

  const locationInfo = data;

  const { cardsData } = useEventCards({ limit: 4, ground: data?.id })
  return (
    <Loading isLoading={isLoading} error={error} data={data}>
      {(data) => {
        const locationInfo = data;
        const conditions = translateTags(locationInfo.conditions);

        const additionally = translateTags(locationInfo.benefits);

        const cardElements = cardsData.map((card: any, index: number) => {
          if (index < 4) {
            return <GameCard
              key={index}
              openState={card.state}
              peopleCount={card.count_participants_total || '0'}
              name={card.name}
              dateTime={card.start_datetime}
              place={card.place}
              imgSrc={card.images}
              tags={card.tags.map((el: any) => el.name)}
              slug={card.slug}
            />
          }
        })
        return (
          <MarginBox>
            <header>
              <Navbar />
            </header>
            <main className="location-meet_main">

              <h1 className="location-meet_h1">{locationInfo.title}</h1>

              <Slider urlImages={locationInfo?.images?.map((image: any) => image.image_link) || []} />

              <div className="location-meet_about">
                <h2>О локации</h2>
                <p>{locationInfo?.description || ''}</p>
              </div>

              <div className="location-meet_description">
                <h2>Описание</h2>

                <div className="location-meet_description-flex">
                  <p className="location-meet_description-flex-item">
                    <span className="location-meet_description-flex-title">Адрес: </span> {locationInfo?.address || ''}
                  </p>

                  <p className="location-meet_description-flex-item">
                    <span className="location-meet_description-flex-title">Тип полигона: </span>
                    {locationInfo?.types?.join(', ') || 'Обычный'}
                  </p >

                  {/* <p className="location-meet_description-flex-item">
                    <span className="location-meet_description-flex-title">Аренда снаряжения:</span> {locationInfo?.rentKit || ''}
                  </p> */}
                </div >

              </div >

              <div className="location-meet_organizers">
                <h2>Владельцы полигона</h2>
                <div className="location-meet_organizers-flex">
                  <div className="location-meet_organizers-flex-item">
                    <img className="location-meet_organizers-flex-item-logo" src={locationInfo?.owner_host?.logo_link || '../EmptyProfileSection/ava_empty.png'} alt="Лого" />
                    <div className="location-meet_organizers-flex-item-info">
                      <p className="location-meet_organizers-flex-item-info-name">{locationInfo?.owner_host?.name}</p>
                      <p>{locationInfo?.owner_host?.tag}</p>
                    </div>
                  </div>
                </div >
              </div >

              <div className="location-meet-conditions">
                <h2>Условия</h2>
                <div className="location-meet_conditions-flex">
                  {conditions}
                </div>
              </div>

              <div className="location-meet-additional">
                <h2>Дополнительно</h2>
                <div className="location-meet_additional-flex">
                  {additionally}
                </div>
              </div>

              <div className="location-meet_map">
                <h2>Как добраться</h2>
                <div className="location-meet_map-container">
                  <Map className="location-meet_map-customMap" coordinates={locationInfo.coordinates} />
                </div>
              </div>

              <div className="location-meet_games">
                <h2>Ближайшие игры</h2>
                <div className="location-meet_games-cards">
                  {cardElements}
                </div>

              </div>

              <Button onClick={() => { navigate('/calendar') }} className="location-meet_button">Показать ещё</Button>

            </main >
            <Footer />
          </MarginBox >

        )
      }}
    </Loading >
  )
}